// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/collapse.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../assets/expand.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.subtitlesWidget{ 
    position: relative;
    background: #FFFFFF;
    box-shadow: 0px 0px 10px rgba(202, 196, 208, 0.56);
    border-radius: 24px;
    padding: 16px 25px;
    padding-bottom: 6px;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    margin-top: -19px; /*compensate uncollapsed gap between video*/
}

.subtitlesWidget--collapsed{
    height: 100%;
    margin-top: 0px;
}

.subtitlesWidget_header{
    display: flex;
    margin-bottom: 34px;

    font-weight: 700;
    font-size: 14px;
    line-height: 24px;
    color: #000000;
    margin-right: 24px;
}

.subtitlesWidget_header_date{
    margin-right: 50px;
}

.subtitlesWidget_header_transcription{

}

.subtitlesWidget_scroll{
    overflow: auto;
    scroll-behavior: smooth;
    height: 100%; 
}

.subtitlesWidget_content{
    display: flex;
    /*gap: 36px;*/
}

.subtitlesWidget_close{
    font-size: 0;
    width: 19px;
    height: 19px;
    position: absolute;
    right: 22px;
    top: 20px;
}

.subtitlesWidget_close::before,
.subtitlesWidget_close::after{
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    background-repeat: no-repeat;
}

.subtitlesWidget_close::after{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    opacity: 0;
}

.subtitlesWidget--collapsed .subtitlesWidget_close::after{
    opacity: 100;
}

.subtitlesWidget--collapsed .subtitlesWidget_close::before{
    opacity: 0;
}`, "",{"version":3,"sources":["webpack://./src/pages/meetingPage/components/subtitlesWidget/SubtitlesWidget.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,kDAAkD;IAClD,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;;IAEtB,iBAAiB,EAAE,2CAA2C;AAClE;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;;IAEnB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;AAEA;;AAEA;IACI,cAAc;IACd,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,SAAS;AACb;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,MAAM;IACN,OAAO;IACP,yDAAwD;IACxD,sBAAsB;IACtB,4BAA4B;AAChC;;AAEA;IACI,yDAAsD;IACtD,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,UAAU;AACd","sourcesContent":[".subtitlesWidget{ \n    position: relative;\n    background: #FFFFFF;\n    box-shadow: 0px 0px 10px rgba(202, 196, 208, 0.56);\n    border-radius: 24px;\n    padding: 16px 25px;\n    padding-bottom: 6px;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n\n    margin-top: -19px; /*compensate uncollapsed gap between video*/\n}\n\n.subtitlesWidget--collapsed{\n    height: 100%;\n    margin-top: 0px;\n}\n\n.subtitlesWidget_header{\n    display: flex;\n    margin-bottom: 34px;\n\n    font-weight: 700;\n    font-size: 14px;\n    line-height: 24px;\n    color: #000000;\n    margin-right: 24px;\n}\n\n.subtitlesWidget_header_date{\n    margin-right: 50px;\n}\n\n.subtitlesWidget_header_transcription{\n\n}\n\n.subtitlesWidget_scroll{\n    overflow: auto;\n    scroll-behavior: smooth;\n    height: 100%; \n}\n\n.subtitlesWidget_content{\n    display: flex;\n    /*gap: 36px;*/\n}\n\n.subtitlesWidget_close{\n    font-size: 0;\n    width: 19px;\n    height: 19px;\n    position: absolute;\n    right: 22px;\n    top: 20px;\n}\n\n.subtitlesWidget_close::before,\n.subtitlesWidget_close::after{\n    content: \"\";\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    background-image: url('../../../../assets/collapse.svg');\n    background-size: cover;\n    background-repeat: no-repeat;\n}\n\n.subtitlesWidget_close::after{\n    background-image: url('../../../../assets/expand.svg');\n    opacity: 0;\n}\n\n.subtitlesWidget--collapsed .subtitlesWidget_close::after{\n    opacity: 100;\n}\n\n.subtitlesWidget--collapsed .subtitlesWidget_close::before{\n    opacity: 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
